/** Native storage errors can have an empty message even when their name is set. */
export function projectStorageErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error || error instanceof DOMException) {
    if (error.message.trim()) return error.message;
    if (error.name === 'QuotaExceededError')
      return 'Not enough browser storage. Free some disk space, then try again.';
  }
  return fallback;
}
